import { t } from 'i18next';

import type { Gender } from 'config/enums';
import { genderTranslateMap } from 'features/collaboration-base/enums';

export const getGenderText = (gender: Gender) => t(genderTranslateMap[gender]);
